import { Button, Card, CardContent } from '@tark/shared/components';
import { useAuth, useTenantBootstrap } from '@tark/shared/hooks';
import { ArrowRightLeft, BookOpenCheck } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import CoachProgramCatalogPanel from './schedule/program-catalog/CoachProgramCatalogPanel';

const MANAGE_ROLES = ['OWNER', 'ADMIN', 'COACH', 'STAFF'];

export default function CoachClassesPage() {
  const { user } = useAuth();
  const { activeTenant } = useTenantBootstrap(Boolean(user));
  const navigate = useNavigate();
  const isCoachStudio = activeTenant?.tenant?.tenantArchetype === 'COACHING';
  const canManageSchedule = MANAGE_ROLES.includes(activeTenant?.roleCode?.toUpperCase() || '');

  if (!isCoachStudio) {
    return (
      <div className="mx-auto max-w-3xl">
        <Card variant="default">
          <CardContent className="space-y-4">
            <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary">
              <BookOpenCheck className="h-6 w-6" />
            </div>
            <div>
              <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-primary">Coach Studio</p>
              <h1 className="mt-2 text-2xl font-semibold tracking-tight text-text">Classes need a Coach Studio</h1>
              <p className="mt-2 text-sm text-text-muted">
                Switch into an enabled coach workspace to manage seasons, programs, and class options.
              </p>
            </div>
            <Button leftIcon={<ArrowRightLeft className="h-4 w-4" />} onClick={() => navigate('/welcome')}>
              Open Home
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <CoachProgramCatalogPanel
      enabled={Boolean(user)}
      canManageSchedule={canManageSchedule}
    />
  );
}
